import { Input, Button, InputGroup, InputGroupText, InputGroupAddon, Modal, ModalBody } from 'reactstrap'
import Switch from 'react-switch'

import { primary_color } from '../../../../../Helper/uiHelper'
import TicketChatListing from './ticketChatList'
import { useEffect, useRef, useState } from 'react'
import { request } from '../../../../../Redux/Sagas/requests/api'
import { cms, editCMS, isSuccessResponse } from '../../../../../helper'
import TicketFileUpload from './ticketFileUpload'
import useOutsideClick from '../../../../../CustomHook/useOutsideClick'
import { useDispatch, useSelector } from 'react-redux'
import { setNotification } from '../../../../../Redux/Reducers/notificationHandling'
import { useHistory } from 'react-router-dom'

const TicketChat = ({ id, ticketDetails, setShowCloseModal, setFAQdetails, getTicketDetails, PERMISSIONS, setTicketDetails }) => {
  const history = useHistory()
  const formRef = useRef(null)
  const dispatch = useDispatch()
  const editMode = useSelector((state) => state.CMS?.editMode)
  const currentUserData = useSelector((state) => state.User.user)

  const [message, setMessage] = useState('')
  const [chats, setChats] = useState([])
  const [file, setFile] = useState()
  const [base64File, setBase64File] = useState()
  const [showFileUpload, setShowFileUpload] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [showReopenModal, setShowReopenModal] = useState(false)
  const [reopeningTicket, setReopeningTicket] = useState(false)

  console.log('permissions::::::', PERMISSIONS)

  useEffect(() => {
    getChat()
  }, [])

  const getChat = () => {
    request('raise-ticket/get/chats', 'POST', { ticket_id: id }).then((res) => {
      setChats(res?.data?.data)
      const data = res?.data?.data?.filter((item) => item.sender_id !== ticketDetails?.ticket?.user_id)
      if (data?.length > 0) {
        const answer = data[data?.length - 1]?.message
        setFAQdetails((value) => {
          return {
            ...value,
            answer,
          }
        })
      }
    })
  }

  const onClearForm = () => {
    setMessage('')
    setBase64File()
    setFile()
  }
  const onPostMessage = () => {
    setIsSubmitted(true)
    const payload = { ticket_id: id, message }
    if (base64File) {
      payload.attachment = base64File
    }
    request('raise-ticket/create/chat', 'POST', payload)
      .then((res) => {
        if (isSuccessResponse(res, 'Message sent successfully!')) {
          getChat()
          onClearForm()
          getTicketDetails()
        }
      })
      .finally(() => setIsSubmitted(false))
  }
  useOutsideClick(formRef, () => {
    setShowFileUpload(false)
    setBase64File()
    setFile()
  })

  const isTicketClosed = ticketDetails?.ticket?.user_status?.toLowerCase() === 'closed'
  const roleId = Number(currentUserData?.role_id)
  // Same roles that can create via Query Tickets "+" (CMS staff, not parent/guest).
  const isStaffActor = [1, 2, 3, 4].includes(roleId)
  const isTicketOwner = currentUserData?.id === ticketDetails?.ticket?.user_id
  // Staff who created the ticket via "+" still act as staff (close / FAQs / replies).
  const actsAsTicketUser = isTicketOwner && !isStaffActor

  return (
    <>
      <div className='mb-3 d-flex justify-content-between'>
        <div style={{ color: primary_color, fontWeight: 'bold' }} className='body1'>
          {isTicketClosed ? (
            ''
          ) : (
            <span
              onClick={() => {
                if (editMode) {
                  editCMS('heading.raise_ticket_response_time_message')
                }
              }}>
              {cms('heading.raise_ticket_response_time_message')}
            </span>
          )}
        </div>
        <div>
          {isTicketClosed && PERMISSIONS?.includes('reopen') && (
            <Button
              color='dark'
              className='subtitle1 mr-3'
              onClick={() => {
                setShowReopenModal(true)
              }}>
              Reopen Ticket<i class='fa-solid fa-sync ml-2'></i>
            </Button>
          )}

          {!actsAsTicketUser && (
            <Button
              color='warning'
              className='subtitle1 mr-3'
              style={{ color: '#4365DE', background: '#4365DE22', border: 'none' }}
              onClick={() => {
                history.push("/faq's-list")
              }}>
              <i class='fa-solid fa-circle-question mr-2'></i> View FAQs
            </Button>
          )}

          <Button
            color='warning'
            onClick={() => {
              getChat()
              getTicketDetails()
              setTimeout(() => {
                dispatch(setNotification({ type: 'success', message: 'Data updated!' }))
              }, 1000)
            }}>
            <i class='fa-solid fa-arrows-rotate text-white'></i>
          </Button>
        </div>
      </div>{' '}
      <div style={{ border: '1px solid #00000012' }}>
        <div className='font-weight-bold body2 p-3' style={{ color: primary_color, background: `${primary_color}12` }}>
          Messages
        </div>
        <div className=' subtitle1 p-2 px-3' style={{ color: primary_color, borderBottom: '1px solid #00000012' }}>
          {ticketDetails?.who_raised?.first_name} {ticketDetails?.who_raised?.surname}
        </div>
        <div>
          <TicketChatListing chats={chats} ticketDetails={ticketDetails} />
        </div>
        <div ref={formRef}>
          {showFileUpload && <TicketFileUpload setBase64File={setBase64File} setFile={setFile} file={file} />}
          {!isTicketClosed && PERMISSIONS?.includes('email toggle') && (
            <div className='d-flex align-items-center p-3' style={{ borderTop: '1px solid #00000012' }}>
              <Switch
                height={22}
                width={45}
                checked={ticketDetails?.is_email}
                onChange={() => {
                  const value = !ticketDetails?.is_email
                  request('raise-ticket/update-email-toggle', 'POST', { ticket_id: id, is_email: value }).then((res) => {
                    if (isSuccessResponse(res, 'Email toggle updated successfully!')) {
                      getTicketDetails()
                    }
                  })
                  setTicketDetails((prev) => {
                    return {
                      ...prev,
                      is_email: !prev?.is_email,
                    }
                  })
                  // onChangeToggle()
                }}
                checkedIcon={null}
                uncheckedIcon={null}
                onColor={primary_color}
              />
              <div className='subtitle1 ml-2'>Send an email with each response.</div>
            </div>
          )}

          <div className='d-flex p-1'>
            <InputGroup>
              <Input
                placeholder='Type your message here'
                className='subtitle1'
                disabled={isTicketClosed}
                value={message}
                onChange={(e) => {
                  setMessage(e.target.value)
                }}
              />
              <InputGroupAddon addonType='append'>
                <Button
                  color='light'
                  style={{ color: primary_color }}
                  disabled={ticketDetails?.ticket?.user_status?.toLowerCase() === 'closed' || isSubmitted}
                  onClick={() => {
                    setShowFileUpload(!showFileUpload)
                  }}>
                  {' '}
                  <i class='fa-solid fa-paperclip'></i>
                </Button>

                <Button
                  className='subtitle1'
                  style={{ background: primary_color }}
                  disabled={(!base64File && !message) || isSubmitted}
                  onClick={() => {
                    onPostMessage()
                  }}>
                  Response
                </Button>
                {!actsAsTicketUser && (
                  <Button
                    color='danger'
                    disabled={isTicketClosed}
                    className='subtitle1'
                    onClick={() => {
                      setShowCloseModal(true)
                    }}>
                    Close
                  </Button>
                )}
              </InputGroupAddon>
            </InputGroup>
          </div>
        </div>
        <Modal
          isOpen={showReopenModal}
          centered={true}
          toggle={() => {
            setShowReopenModal(false)
          }}
          style={{ width: '30rem', boxShadow: 'none', maxWidth: '50rem' }}>
          <ModalBody>
            <div
              style={{ backgroundColor: '#FFF', border: 'none', padding: '2rem', color: primary_color }}
              className='font-weight-bold body1 text-center'>
              Are you sure you want to reopen the ticket?
            </div>
            <div className='d-flex justify-content-between'>
              <button
                className='btn rounded-pill mt-2 text-danger border-danger'
                type='button'
                onClick={() => {
                  setShowReopenModal(false)
                }}
                style={{ fontWeight: 700, width: '48%' }}>
                Cancel
              </button>
              <button
                className='btn text-white rounded-pill mt-2'
                type='button'
                disabled={reopeningTicket}
                onClick={() => {
                  setReopeningTicket(true)
                  request('raise-ticket/reopen-ticket', 'POST', { ticket_id: id }).then((res) => {
                    if (isSuccessResponse(res, 'Ticket reopened successfully!')) {
                      getTicketDetails()
                    }
                    setShowReopenModal(false)
                    setReopeningTicket(false)
                  })
                }}
                style={{ background: primary_color, fontWeight: 700, width: '48%' }}>
                Yes
              </button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    </>
  )
}

export default TicketChat
